import { useEffect, useRef, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserAltSlash } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import axios from "axios";

import styles from "../styles/style.module.css";
import commonStyles from "../../../lib/common/common.module.css";
import { APP_ROUTES, LOCAL_CONSTANTS } from "../../../lib/constants";
import { UserTypes } from "../../../interfaces";
import { list, update, uploadBulk, warehouseList } from "../api";
import Layout from "../../../ui/layout";
import { IMAGES } from "../../../assets/images";
import { DropDownMenu, ActionButton, Pagination, Popup } from "../../../ui";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import SelectColumns from "../../../ui/Popup/selectColumn";
import { getRole } from "../../../lib/common/common";
// import { WarehouseResponse, Warehouse, WarehousePagination } from '../interfaces/warehouse';

const Iccid = () => {
  const location = useLocation();
  const navigate = useNavigate();

   const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/sample.xlsx'; // Path to the file in the public folder
    link.download = 'sample.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
  // useEffect(() => {   
  //   const roles: any = window.localStorage.getItem("admin_roles")
  //   if (roles == 4 || roles == 5) return navigate(APP_ROUTES.PARTNERS);
  // },[])
  const [pagination, setPagination] = useState({
    skip: 0,
    limit: LOCAL_CONSTANTS.limitCount,
  });
  const [search, setSearch] = useState<string | null>(null);
  const [order, setSortOrder] = useState<number>(0);
  const [sortBy, setSortColumn] = useState<string>("");
  const [blockedAccounts, setBlockedAccounts] = useState<boolean | null>(null);
  const [verifiedEmailAccount, setVerifiedEmailAccounts] = useState<boolean | null>(null);
  const [verifiedPhoneNoAccount, setVerifiedPhoneNoAccounts] = useState<boolean | null>(null);
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [show, setShow] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState<any[]>(LOCAL_CONSTANTS.iccidTableHeaders.slice(0,10));
  const [users, setUsers] = useState<{ list: any[]; count: number }>({
    list: [],
    count: 0,
  });

   const fileInputRef = useRef<HTMLInputElement>(null);

  const [loading, setLoading] = useState<boolean>(true);
  const [dialog, setDialog] = useState({ show: false, id: "", status: false });
  const [showBulkModal, setShowBulkModal] = useState(false);
  const [selectedType, setSelectedType] = useState<any>(null);
 
 const [warehouses, setWarehouses] = useState<any[]>([]);

  const [loadingWarehouses, setLoadingWarehouses] = useState(false);

  const [showUploadModal, setShowUploadModal] = useState(false);   
const [showErrorModal,  setShowErrorModal]  = useState(false);   


const [errorList, setErrorList] = useState<string[]>([]);      


  const [file, setFile] = useState<File | null>(null);
  const [isUploading, setIsUploading] = useState(false);

  // ① Handle file-picker change
  const handleChange = (e:any) => {
    const selected = e.target.files?.[0];
    if (selected) setFile(selected);
  };


  const listUsers = (
    pageIndex = pagination.skip,
    isBlocked: boolean | null = null,
    isPhoneNoVerified: boolean | null = null,
    isEmailVerified: boolean | null = null
  ) => {
    let query: any = {
      page: (1 + pageIndex),
      limit: pagination.limit,
     ...searchObject,
    };

    if (search) {
      query['search'] = search;
    }
    if (startDate) {
      query.startDate = startDate;
    }
    if (endDate) {
      query.endDate = endDate;
    }
    list(query).then(({ data }) => {
      setUsers({ list: data.formattedIccids
        , count: data.count });
      setLoading(false);
    });
  };
const handleSelectColumn = () => {
setShow(true);
}
const [searchObject, setSearchObject] = useState({});
  useEffect(() => {
    setLoading(true);
    const debounceSearch = setTimeout(() => {
      listUsers();
    }, 500);
    return () => {
      clearTimeout(debounceSearch);
    };
  }, [pagination ,searchObject]);

  useEffect(() => {
    console.log(searchObject, "searchObject")
  }, [searchObject]);


  const blockUnblockUser = () => {
    const payload = {
      userId: dialog.id,
      isBlocked: dialog.status,
    };
    toast.promise(
      update(payload),
      {
        pending: {
          render() {
            return LOCAL_CONSTANTS.updatingUser;
          },
        },
        success: {
          render() {
            let tempUser = users.list;
            let index = tempUser.findIndex((item) => item._id === dialog.id);

            tempUser[index].isBlocked = !tempUser[index].isBlocked;

            setUsers({ ...users, list: tempUser });

            setDialog({ show: false, id: "", status: false });
            return dialog.status
              ? LOCAL_CONSTANTS.userBlockedSuccessfully
              : LOCAL_CONSTANTS.userUnblockedSuccessfully;
          },
        },
        error: {
          render() {
            return LOCAL_CONSTANTS.errorOnUpdatingUser;
          },
        },
      });
  };

  const handleSort = (column: string) => {
    setSortColumn(column);
    setSortOrder(
      order === LOCAL_CONSTANTS.descKey
        ? LOCAL_CONSTANTS.ascKey
        : LOCAL_CONSTANTS.descKey
    );
    const query = {
      ...pagination,
      search,
      order:
        order === LOCAL_CONSTANTS.descKey
          ? LOCAL_CONSTANTS.ascKey
          : LOCAL_CONSTANTS.descKey,
      sortBy: column,
    };
    list(query).then(({ data }) => {
      setUsers({ list: data.formattedIccids
        , count: data.count });
      setLoading(false);
    });
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const selected = e.target.files?.[0];
  setFile(selected ?? null);
};

const handleUploadPlans = async () => {
  if (!file) {
    toast.error("Please select a file first");
    return;
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("warehouseId", selectedType?.value || "");

  try {
    setIsUploading(true);

    /* ─── call API ─── */
    const res     = await uploadBulk(formData);
    const payload = res?.data ?? res;            // Axios vs. plain JSON
    const { errors = [], message } = payload;

    if (errors.length) {
      /* ➊ save errors ➋ swap modals  */
      setErrorList(errors);
      setShowUploadModal(false);    // close the original dialog
      setShowErrorModal(true);      // open the error dialog
      setShowBulkModal(false);
      setFile(null)
      setSelectedType(null);
      return;                       // don’t continue to success logic
    }

    // success path (no errors)
    toast.success(message || `${file.name} uploaded successfully!`);
    setShowUploadModal(false);
  } catch (err: any) {
    toast.error(
      err?.response?.data?.message || err.message || "Unknown error"
    );
  } finally {
    setIsUploading(false);
  }
};


// const handleUploadPlans = async () => {
//   if (!file) {
//     toast.error("Please select a file first");
//     return;
//   }

//   const formData = new FormData();
//   formData.append("file", file);
//   formData.append("warehouseId", selectedType?.value || "");

//   try {
//     setIsUploading(true);

//     // If uploadBulk returns the raw Axios response, grab response.data;
//     // if it already returns JSON, payload will *be* that JSON.
//     const res      = await uploadBulk(formData);
//     const payload  = res?.data ?? res;

//     // Destructure the interesting bits
//     const { errors = [], message, statistics } = payload;

//     /* ------------------------- show toast -------------------------- */
//     if (Array.isArray(errors) && errors.length) {
//       // Print each error line in its own red toast
//       errors.forEach((e: string) => toast.error(e));

//       // Optional summary
//       toast.warn(
//         `Completed with ${statistics?.failed ?? errors.length} failure${
//           errors.length > 1 ? "s" : ""
//         } out of ${statistics?.total ?? "?"}`
//       );
//     } else {
//       toast.success(message || `${file.name} uploaded successfully!`);
//     }
//   } catch (err: any) {
//     const apiError =
//       err?.response?.data?.message || err.message || "Unknown error";
//     toast.error(`Upload failed: ${apiError}`);
//   } finally {
//     setIsUploading(false);
//   }
// };


//   const handleUploadPlans = async () => {
//   if (!file) {
//     toast.error("Please select a file to upload.");
//     return;
//   }

//   console.log(file, "------")

//  const formData = new FormData();
//   formData.append("file", file);
//   formData.append("warehouseId", selectedType.value);

//   try {
//     setIsUploading(true);

//     console.log(formData, "---formData")
//     await uploadBulk(formData);
//     toast.success(`${file.name} uploaded successfully!`);
//     // listPlans();
//   } catch {
//     toast.error(`Failed to upload ${file.name}.`);
//   } finally {
//     setIsUploading(false);
//   }
// };
  //  const handleUploadPlans = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const file = event.target.files?.[0];

  //   if (!file) {
  //     toast.error("Please select a file to upload.");
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append("file", file);

  //   uploadBulk(formData)
  //     .then((response:any) => {
  //       toast.success(`${file.name} uploaded successfully!`);
  //       // listPlans(); // Refresh the plans after upload
  //     })
  //     .catch((error:any) => {
  //       toast.error(`Failed to upload ${file.name}.`);
  //     });
  // };

  const handleBulkModalClose = () => {
    setShowBulkModal(false);
    setSelectedType(null);
    setFile(null)
  };

  const handleBulkModalOpen = () => {
    setShowBulkModal(true);
  };

  const handleBulkUpload = () => {
    // Handle bulk upload logic here
    toast.success("Bulk upload initiated");
    handleBulkModalClose();
  };


  const handleBulkPreview = () => {
    // Handle bulk preview logic here
    toast.success("Bulk preview initiated");
    handleBulkModalClose();
  };

const fetchWarehouses = async () => {
  try {
    setLoadingWarehouses(true);
    const response = await warehouseList({ page: 1, limit: 10 });

    if (response.statusCode === 200) {
      // just store the list; don’t touch selectedType
      setWarehouses(response.data.data);
    }
  } catch (err) {
    toast.error("Failed to fetch warehouses");
    console.error("Error fetching warehouses:", err);
  } finally {
    setLoadingWarehouses(false);
  }
};

  useEffect(() => {
    if (showBulkModal) {
      fetchWarehouses();
    }
  }, [showBulkModal]);

const warehouseOptions = warehouses.map(warehouse => ({
  value: warehouse._id,
  label: `${warehouse.warehouseName} (${warehouse.country.name})`
}));


  return (
    <Layout title="ICCID">
      <div className={commonStyles.tableData}>
        <div className={commonStyles.topFilter}>

          <div className={`d-flex gap-3 align-items-center w-100 ${styles.filterSlect}`}>
    
            <button
            onClick={handleSelectColumn}
            className={`mt-4 ${styles.loyalityPointBtn}`}
          >
           Select Columns
          </button>
          


          
<label 
  onClick={handleBulkModalOpen} 
  className={`mt-4 ${styles.loyalityPointBtn}`} 
  style={{ cursor: "pointer" }}
>
  Add Bulk
</label>
{/* <label onClick={handleDownload} className={`mt-4 ${styles.loyalityPointBtn}`} style={{  cursor: "pointer",  }}>
  Download Sample

</label> */}
        
          </div>
        </div>
        <div className={styles.scrollTable}>
          <table>
            <thead>
              <tr>
                {selectedColumns?.map((header: UserTypes.TableHeader) => (
                  selectedColumns.includes(header)&&<th
                    className={`${["fullName", "phoneNumber"].includes(header?.value)
                      ? "cursor-pointer"
                      : ""
                      }`}
                    onClick={() => {
                      if (["fullName", "phoneNumber"].includes(header?.value)) {
                        handleSort(header?.value);
                      }
                    }}
                    key={header?.value}
                  >
                    {header?.label}
                    {/* {sortBy === header?.value &&
                      ["fullName", "phoneNumber"].includes(header?.value) &&
                      renderSortIcon(header?.value)} */}
                      <div className={commonStyles.topFilter}>
                      <div className={styles.date_calender}>
         { header.label!=="Actions" &&header.label!=="Date"&&header.label!=="Role"&&header.label!=="Blocked"&&<input
           
            onChange={(e) => {
              setSearchObject({ ...searchObject, [header.value]: e.target.value });
            }}
            
       
          />}
         
          </div>
          { header.label==="Role"&& <div className="w-100">
             
              <Select
                options={LOCAL_CONSTANTS.ZOLVE_ROLES}
                onChange={(response) => {
                  if (response) {
                    let pageIndex = 0;
                    let status = response.value;

                    setSearchObject({ ...searchObject, [header.value]: response.value });
                    // listUsers(pageIndex, blockedAccounts, verifiedPhoneNoAccount, status);
                  }
                }}
                defaultValue={{value:"", label:"Select Role"}}
                className="w-100"
              />
              </div>}
              { header.label==="Blocked"&& <div className="w-">
             
             <Select
               options={LOCAL_CONSTANTS.blockedAccounts}
               onChange={(response) => {
                 if (response) {
                   let pageIndex = 0;
                   let status = response.value;

                   setSearchObject({ ...searchObject, [header.value]: response.value });
                   // listUsers(pageIndex, blockedAccounts, verifiedPhoneNoAccount, status);
                 }
               }}
               defaultValue={LOCAL_CONSTANTS.blockedAccounts[0]}
               className="w-100"
             />
             </div>}

              {header.label==="Date"&&
                <div className={styles.date_calender}>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => {
                    setSearchObject({ ...searchObject, [header.value]: e.target.value });
                    setStartDate(e.target.value)}}
                  placeholder="Start Date"
                />
              </div>
              }
                      </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td colSpan={7} align="center" className={styles.loadingText}>
                    {LOCAL_CONSTANTS.loading}
                  </td>
                </tr>
              )}
              {!loading && users.list?.length === 0 && (
                <tr>
                  <td colSpan={7} align="center">
                    No User Found
                  </td>
                </tr>
              )}
              {!loading &&
                users.list.map((item) => (
                  <tr>{selectedColumns.map((rr)=>{
                    if(rr.value==="brand"){
                      return <td>{item.brand?.name}</td>
                    }else if(rr.value==="iccid"){
                      return <td>{item.iccid}</td>
                    }else if(rr.value==="Warehouse Name"){
                      return <td>{item?.warehouseId?.warehouseName || 'N/A'}</td>
                    }else if(rr.value==="createdAt"){
                      return <td>{moment.utc(item.createdAt).format("DD/MM/YYYY")}</td>
                    }else if(rr.value==="status"){
                      return <td>{item.status}</td>
                    }else if(rr.value==="type"){
                      return <td>{item.type}</td>
                    }
                    else if(rr.value==="actions"){
                      return <></>
                  }
                  else if(rr.value==="id"){
                    return <td>{item._id}</td>
                }
                  else{
                    return <td>N/A</td>
                  }})}</tr>))}
                  
                 
                
            </tbody>
          </table>
        </div>
        <Pagination
          paginationState={pagination}
          setPaginationState={setPagination}
          count={users.count}
        />
        <Popup
          show={dialog.show}
          handleClose={() => setDialog({ show: false, id: "", status: false })}
          heading={LOCAL_CONSTANTS.areYouSure}
          content={LOCAL_CONSTANTS.areYouSureRestrictUserAccess}
          handleSubmit={blockUnblockUser}
          id={dialog.id}
        />
        <SelectColumns selectedColumns={selectedColumns} setSelectedColumns={setSelectedColumns} show={show} handleClose={()=>setShow(false)} iso="" columns={LOCAL_CONSTANTS.iccidTableHeaders} />
 
      </div>


      <Modal
  show={showErrorModal}
  onHide={() => setShowErrorModal(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Upload completed with errors</Modal.Title>
  </Modal.Header>

  <Modal.Body style={{ maxHeight: "60vh", overflowY: "auto" }}>
    {errorList.length === 0 ? (
      <p className="mb-0">No errors to display.</p>
    ) : (
      <ul className="list-unstyled mb-0">
        {errorList.map((err, i) => (
          <li key={i} className="text-danger small">
            {err}
          </li>
        ))}
      </ul>
    )}
  </Modal.Body>

  <Modal.Footer>
    <button
      className={styles.button}
      onClick={() => setShowErrorModal(false)}
    >
      Close
    </button>
  </Modal.Footer>
</Modal>

      {/* Add Bulk Modal */}
 <Modal show={showBulkModal} onHide={handleBulkModalClose} centered>
      <Modal.Header className={styles.modHead} closeButton />
      <Modal.Body className={styles.faqContent}>
        <div className="mb-4">
          {/* hidden file picker */}
          <input
            ref={fileInputRef}
            type="file"
            accept=".csv,.xlsx,.pdf,image/*"
            hidden
            onChange={handleFileChange}
          />
          <button
            className={styles.button}
            onClick={() => fileInputRef.current?.click()}
          >
            Choose File
          </button>
          {file && (
            <div className="text-success small mt-1">{file.name} selected</div>
          )}

          {/* warehouse selector */}
          <label className="w-100 mb-2 mt-3">Select Warehouse</label>
          <Select
            options={warehouseOptions}
            value={selectedType}
            onChange={(s) => setSelectedType(s)}
            placeholder="Select a warehouse"
            className="w-100"
            isLoading={loadingWarehouses}
            isDisabled={loadingWarehouses}
          />
        </div>

        {/* action buttons */}
        <div className="d-flex justify-content-between gap-3">
          <button
            className={`${styles.button} flex-grow-1`}
            onClick={handleUploadPlans}
            disabled={!file || !selectedType || isUploading}
          >
            {isUploading ? "Uploading…" : "Upload"}
          </button>

          <button
            className={`${styles.button} flex-grow-1`}
            onClick={handleDownload}
            // disabled={!selectedType}
          >
            Download
          </button>

          <button
            className={`${styles.button} flex-grow-1`}
            onClick={handleBulkModalClose}
          >
            Cancel
          </button>
        </div>
      </Modal.Body>
    </Modal>

    </Layout>
  );
};

export default Iccid;
